__turbopack_context__.v({
  "allCaseStudiesButton": "PlasmicHomeCaseStudiesSection-module__N90TxW__allCaseStudiesButton",
  "allCaseStudiesButton2": "PlasmicHomeCaseStudiesSection-module__N90TxW__allCaseStudiesButton2",
  "banner": "PlasmicHomeCaseStudiesSection-module__N90TxW__banner",
  "bannerContainer": "PlasmicHomeCaseStudiesSection-module__N90TxW__bannerContainer",
  "bannerLabelProvider": "PlasmicHomeCaseStudiesSection-module__N90TxW__bannerLabelProvider",
  "bannerVariantProvider": "PlasmicHomeCaseStudiesSection-module__N90TxW__bannerVariantProvider",
  "buttonWrapper": "PlasmicHomeCaseStudiesSection-module__N90TxW__buttonWrapper",
  "caseStudies": "PlasmicHomeCaseStudiesSection-module__N90TxW__caseStudies",
  "desktop": "PlasmicHomeCaseStudiesSection-module__N90TxW__desktop",
  "freeBox___5ME2": "PlasmicHomeCaseStudiesSection-module__N90TxW__freeBox___5ME2",
  "freeBox__aqMob": "PlasmicHomeCaseStudiesSection-module__N90TxW__freeBox__aqMob",
  "freeBox__drdSu": "PlasmicHomeCaseStudiesSection-module__N90TxW__freeBox__drdSu",
  "freeBox__uFkPq": "PlasmicHomeCaseStudiesSection-module__N90TxW__freeBox__uFkPq",
  "homeCaseStudiesSectionBanner___1OTky": "PlasmicHomeCaseStudiesSection-module__N90TxW__homeCaseStudiesSectionBanner___1OTky",
  "homeCaseStudiesSectionBanner___2OdIq": "PlasmicHomeCaseStudiesSection-module__N90TxW__homeCaseStudiesSectionBanner___2OdIq",
  "homeCaseStudiesSectionBanner__ypcO": "PlasmicHomeCaseStudiesSection-module__N90TxW__homeCaseStudiesSectionBanner__ypcO",
  "img": "PlasmicHomeCaseStudiesSection-module__N90TxW__img",
  "left": "PlasmicHomeCaseStudiesSection-module__N90TxW__left",
  "nav": "PlasmicHomeCaseStudiesSection-module__N90TxW__nav",
  "navBackButton": "PlasmicHomeCaseStudiesSection-module__N90TxW__navBackButton",
  "navForwardButton": "PlasmicHomeCaseStudiesSection-module__N90TxW__navForwardButton",
  "navigationBullet": "PlasmicHomeCaseStudiesSection-module__N90TxW__navigationBullet",
  "row": "PlasmicHomeCaseStudiesSection-module__N90TxW__row",
  "sectionHeader": "PlasmicHomeCaseStudiesSection-module__N90TxW__sectionHeader",
  "sliderCarousel": "PlasmicHomeCaseStudiesSection-module__N90TxW__sliderCarousel",
  "sliderNavigation": "PlasmicHomeCaseStudiesSection-module__N90TxW__sliderNavigation",
  "svg___30Xq": "PlasmicHomeCaseStudiesSection-module__N90TxW__svg___30Xq",
  "svg__daIjG": "PlasmicHomeCaseStudiesSection-module__N90TxW__svg__daIjG",
  "svg__fouXh": "PlasmicHomeCaseStudiesSection-module__N90TxW__svg__fouXh",
  "svg__qr8Y": "PlasmicHomeCaseStudiesSection-module__N90TxW__svg__qr8Y",
  "svg__vcw6E": "PlasmicHomeCaseStudiesSection-module__N90TxW__svg__vcw6E",
  "svg__wOk2J": "PlasmicHomeCaseStudiesSection-module__N90TxW__svg__wOk2J",
  "wrapper": "PlasmicHomeCaseStudiesSection-module__N90TxW__wrapper",
});
